import type { Song } from "../types";

/** Itsy Bitsy Spider (traditional, public domain). */
export const itsyBitsySpider: Song = {
  id: "itsy-bitsy-spider",
  title: "Itsy Bitsy Spider",
  bpm: 105,
  instrument: "piano",
  notes: [
    { key: "G4", beats: 0.5 },
    { key: "C4", beats: 1 },
    { key: "C4", beats: 0.5 },
    { key: "C4", beats: 1 },
    { key: "D4", beats: 0.5 },
    { key: "E4", beats: 1.5 },
    { key: "E4", beats: 1 },
    { key: "E4", beats: 0.5 },
    { key: "D4", beats: 1 },
    { key: "C4", beats: 0.5 },
    { key: "D4", beats: 1 },
    { key: "E4", beats: 0.5 },
    { key: "C4", beats: 2.5 },
    { key: "E4", beats: 1 },
    { key: "E4", beats: 0.5 },
    { key: "F4", beats: 1 },
    { key: "G4", beats: 0.5 },
    { key: "G4", beats: 1.5 },
    { key: "F4", beats: 1 },
    { key: "E4", beats: 0.5 },
    { key: "F4", beats: 1 },
    { key: "G4", beats: 0.5 },
    { key: "E4", beats: 2.5 },
  ],
};
